import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { BUTTON_SIZES } from 'src/editor-v3/components/buttons/button/Button.constants';
import { IconQuaternaryOnLightButton } from 'src/editor-v3/components/icon-buttons/icon-quaternary-on-light-button/IconQuaternaryOnLightButton';
import { BOTTOM_SHEET_VIEWS } from 'src/store/bottom-sheet/bottomSheet.constants';
import { SAVING_STATE } from 'src/store/page-project/pageProject.constants';
import { SaveButtonProps } from '../SaveButton.types';

export const SaveButtonMobile = observer(({ focusId, focusOrder, focusGroup }: SaveButtonProps) => {
  const {
    i18n,
    project: { activeProject, isUploading },
    bottomSheet: { openBottomSheet },
    user: { isLogged: isUserLogged },
  } = useStore();

  return (
    <IconQuaternaryOnLightButton
      accessible={true}
      accessibilityLabel={i18n.t('header:save')}
      onPress={async () => {
        openBottomSheet({
          bottomSheetView: !isUserLogged ? BOTTOM_SHEET_VIEWS.Login : BOTTOM_SHEET_VIEWS.SaveProject,
          showDragIndicator: false,
          showOpacityBackground: true,
        });
      }}
      focusId={focusId}
      focusOrder={focusOrder}
      focusGroup={focusGroup}
      size={BUTTON_SIZES.SMALL}
      iconName={ICON_NAMES.Saved}
      loading={activeProject!.savingState === SAVING_STATE.saving || isUploading}
    />
  );
});
